<template>
  <div class="box">
    <div class="columns">
      <div class="column">
        <b-field grouped group-multiline position="is-right" v-if="!user.id">
          <div class="control is-flex">
            <b-switch v-model="isPaginated" size="is-small">{{ $t('isPaginated') }}</b-switch>
          </div>

          <div class="control is-flex">
            <b-switch v-model="showBrought" size="is-small">{{ $t('showBrought') }}</b-switch>
          </div>
        </b-field>

        <div v-if="filteredItems.length === 0" class="section">
          <div class="content has-text-grey has-text-centered">
            <p v-html="$t('emptyItemList')"></p>
          </div>
        </div>

        <b-table
          :data="filteredItems.length === 0 ? [] : filteredItems"
          :striped="true"
          :mobile-cards="true"
          default-sort="name"
          :checked-rows.sync="checkedItems"
          :checkable="!user.id && filteredItems.length > 0"
          :paginated="isPaginated && !user.id"
          :per-page="perPage"
          :current-page.sync="currentPage"
          v-else
        >

          <template slot-scope="props">
            <b-table-column field="name" :label="$t('item.name')" sortable>
              <span :class="{ 'is-strikethrough': isBrought(props.row) }">{{ props.row.name }}</span>
            </b-table-column>

            <b-table-column field="quantity" :label="$t('item.quantity')" sortable numeric>
              {{ props.row.quantity }} {{ $t('units.' + props.row.unit) }}
            </b-table-column>

            <b-table-column field="type" :label="$t('item.type')">
              <b-tag :type="getTypeColor(props.row.type)">{{ $t('types.' + props.row.type) }}</b-tag>
            </b-table-column>
          </template>

          <template slot="empty">
            <div class="section">
              <div class="content has-text-grey has-text-centered">
                <p v-html="$t('emptyItemList')"></p>
              </div>
            </div>
          </template>

          <template slot="bottom-left" v-if="filteredItems.length > 0">
            <strong>{{ checkedItems.length }}</strong>&nbsp;{{ $t('selectedItems') }}
          </template>
        </b-table>
      </div>
    </div>

    <div class="columns" v-if="!user.id && checkedItems.length > 0">
      <div class="column">
        <user-box-form :event="event" :items="checkedItems"></user-box-form>
      </div>
    </div>
  </div>
</template>

<script>
  import Item from './Item.vue'
  import { mapState } from 'vuex'
  import { globalMethods } from '@/shared/mixins'
  import UserBoxForm from '@/components/UserBoxForm'

  export default {
    name: 'item-list',
    components: {
      UserBoxForm,
      Item
    },
    mixins: [globalMethods],
    props: {
      items: {
        type: Array,
        required: true
      },
      user: {
        type: Object,
        required: false
      },
      event: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        showBrought: true,
        isPaginated: true,
        currentPage: 1,
        perPage: 5,
        checkedItems: []
      }
    },
    computed: {
      ...mapState({
        typesFilter: state => state.filters.types
      }),
      filteredItems () {
        return this.items.filter(item => {
          if (!this.user.id && this.isBrought(item) && !this.showBrought) {
            return false
          } else {
            return (this.typesFilter.length <= 0 || this.typesFilter.includes(item.type))
          }
        })
      }
    },
    methods: {
      isBrought (item) {
        let broughtItems = {}

        if (this.event.participants) {
          for (let participant of this.event.participants) {
            for (let userItem of participant.items) {
              if (broughtItems[userItem.name]) {
                broughtItems[userItem.name].quantity += userItem.quantity
              } else {
                broughtItems[userItem.name] = Object.assign({}, userItem)
              }
            }
          }

          return !this.user.id && !!(broughtItems[item.name] && broughtItems[item.name].unit === item.unit && broughtItems[item.name].quantity >= item.quantity)
        } else {
          return false
        }
      }
    }
  }
</script>

<style>
  /* [Buefy] */

  .b-table .level {
    padding-bottom: 0;
  }
</style>

<style lang="scss" scoped>
  .table {
    margin-bottom: 0;

    th {
      width: 25%;
    }
  }

  /* [Bulma] */

  .is-strikethrough {
    text-decoration: line-through;
  }
</style>



// WEBPACK FOOTER //
// src/components/ItemList.vue